import { Exclude } from 'class-transformer';
import { BaseItem } from './base-item.model';

export enum FamilyStatus {
  // Spouse = 'Spouse',
  Partner = 'Partner',
  Child = 'Child',
  Parent = 'Parent'
}

interface RelationshipAttributes {
  person_id: string;
  relative_id: string;
  name: FamilyStatus;
}

@Exclude()
export class Relationship extends BaseItem<RelationshipAttributes> {}
